import React from "react";
import logo from "../../../assets/Navbar/logo-white.png";
import "../Footer/Footer.css"; 

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <section className="footer p-md-5 p-3">
      <div className="container-fluid ">
        <div className="footer-container container-fluid px-md-5 px-0">
          <div className="row pb-3">
            <div className="col-md-6">
              {/* <img
                src={logo}
                alt="Logo"
                className="img-fluid footer-logo pb-5"
              /> */}
              <h5 className="footer-text b-0 lh-base footer-address pb-2">BELANTARA BEACH ESTATE</h5>
              <h5 className="text-white b-0 lh-base footer-address">
                Pagerewadi Khavne, Vengurla, Sindhudurg
                <br />
                Maharashtra 416522
                <br />
                Contact us: +91 820 805 3493
              </h5>
            </div>

            <div className="col-md-6 d-flex align-items-end justify-content-start">
            <div className="footer-icons  d-flex align-items-end justify-content-start gap-4">
            <a href="https://www.facebook.com/people/Belantara-Beach-Estate/61570971933788/" className="text-decoration-none">
              <i className="ri-facebook-circle-fill"></i>
            </a>
            <a href="https://www.instagram.com/belantarabeachestate/" className="text-decoration-none">
              <i className="ri-instagram-fill"></i>
            </a>
            <a href="https://www.youtube.com/@belantarabeachestate" className="text-decoration-none">
              <i className="ri-youtube-fill"></i>
            </a>
          </div>
            </div>

            {/* <div className="col-md-6 d-flex flex-column justify-content-end">
              <h4 className="footer-text">Send Us a Message</h4>
              <form>
                <div className="input-box gap-2 flex-wrap">
                  <div className="col-md-8">
                    <input
                      type="email"
                      className="form-control email ps-2 bg-transparent text-white"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder="Enter Your Email"
                    />
                  </div>
                  <button type="submit" className="border-0 mt-2 bg-transparent">
                    <div className="footer-btn d-block">
                      <a href="#" className="text-white text-decoration-none">
                        Subscribe
                      </a>
                    </div>
                  </button>
                </div>
              </form>
            </div> */}
          </div>

         
        </div>

        <div className="footer-div">
          <div className="footer-links container py-md-5 py-3">
            <a href='/#Discoversect'>Discover</a>
            <a href="/#Villas">Residences</a>
            {/* <a href="/#Activities">Activities</a> */}
            <a href="/#Allprograms">Programs</a>
            <a href="/#Exquisite">Food Menu</a>
            <a href="/gallery">Gallery</a>
            <a href="/contact">Contact</a>
          </div>
        </div>
        <div className="container copyrights pt-5">
          <p className="text-white text-center">
            Copyright © <span>{currentYear}</span> Belantara Beach Estate
          </p>
          {/* <p className="text-white text-center">
            Powered by Belantara Beach Estate
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default Footer;
